import { render, staticRenderFns } from "./OrganizerDetails.vue?vue&type=template&id=0989bd1b&scoped=true&"
import script from "./OrganizerDetails.vue?vue&type=script&lang=js&"
export * from "./OrganizerDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrganizerDetails.vue?vue&type=style&index=0&id=0989bd1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0989bd1b",
  null
  
)

export default component.exports